import Tooltip from 'rc-tooltip';

const TooltipComponent = ({ className, children, ...tooltipProps }) => (
  <Tooltip overlayClassName={className} destroyTooltipOnHide {...tooltipProps}>
    <span className='tooltip-child'>{children}</span>
  </Tooltip>
);

export default TooltipComponent;
